import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBible = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M6.22,0C4.11,0,2.399,1.71,2.399,3.821v16.576c0,1.99,1.614,3.603,3.604,3.603H20.88c0.397,0,0.719-0.321,0.719-0.72v-0.96 c0-0.399-0.322-0.72-0.719-0.72H6.259c-0.807,0-1.459-0.537-1.459-1.202s0.653-1.203,1.459-1.203h14.622 c0.397,0,0.72-0.323,0.72-0.72V0.72c0-0.399-0.322-0.72-0.72-0.72H6.22z M17.414,9.671h-2.439v5.599 c0,0.397-0.321,0.718-0.719,0.718h-1.722c-0.397,0-0.719-0.321-0.719-0.718V9.671h-2.44c-0.398,0-0.719-0.321-0.719-0.72V7.229 c0-0.397,0.321-0.719,0.719-0.719h2.44V4.069c0-0.397,0.322-0.719,0.719-0.719h1.722c0.398,0,0.719,0.321,0.719,0.719v2.441h2.441 c0.397,0,0.719,0.321,0.719,0.719v1.721C18.133,9.348,17.812,9.671,17.414,9.671L17.414,9.671z"
	})
});
export default SvgBible;
